import { Route, Routes } from 'react-router-dom'
import AddressChangePage from './Page'

export default function AddressChange() {
  return (
    <Routes>
      <Route path="/*" element={<AddressChangePage />} />
      <Route path="/:id" element={<AddressChangePage />} />
      <Route path="/:id/:section" element={<AddressChangePage />} />
    </Routes>
  )
}
